// extracted by mini-css-extract-plugin
export default {"container":"AZ-z","title":"BZ-z","link":"CZ-z"};